export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Counterparty information"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID / Account / E-mail / Phone"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID / Crypto address / E-mail / Phone"])}
}